import React, {useState} from 'react';
import PropTypes from 'prop-types';
import EmptyState from '../../../../components/EmptyState/EmptyState';
import {
  Section,
  LabelGrid,
  LabelCard,
  LabelName,
  LabelValue,
  Tooltip,
  Link,
} from './TyreEULabel.style';

const tooltipTexts = {
  'Učinkovitost porabe goriva': 'Nižje ocene pomenijo boljšo porabo goriva',
  'Oprijem na mokrem':
    'Višje ocene pomenijo boljše zavorne zmogljivosti na mokrih cestah',
  'Zunanji hrup kotaljenja': 'Razred hrupa od A (tiho) do C (glasno)',
  'Raven hrupa': 'Zunanji hrup kotaljenja, merjen v decibelih',
  '3PMSF': '3-vrh gorski snežni simbolček za hude snežne razmere',
  'Ledeni piktogram':
    'Označuje zmogljivost oprijema na z ledom pokritih cestah',
};

const TyreEULabel = ({euLabel, t}) => {
  const [hoveredLabel, setHoveredLabel] = useState(null);

  const labelData = [
    {
      label: 'Učinkovitost porabe goriva',
      value: euLabel.FUEL_EFFI || euLabel.FUEL_EFFI_E2,
      icon: 'mdi-gas-station',
    },
    {
      label: 'Oprijem na mokrem',
      value: euLabel.WET_GRIP || euLabel.WET_GRIP_E2,
      icon: 'mdi-water',
    },
    {
      label: 'Zunanji hrup kotaljenja',
      value: euLabel.ROLL_NOISE || euLabel.ROLL_NOISE_E2,
      icon: 'mdi-volume-high',
    },
    {
      label: 'Enota hrupa',
      value: euLabel.NOISE_UNIT || euLabel.NOISE_UNIT_E2,
      icon: 'mdi-speaker',
    },
    {
      label: 'Raven hrupa',
      value: euLabel.NOISE_LEV || euLabel.NOISE_LEV_E2,
      icon: 'mdi-chart-bar',
    },
    {
      label: 'Razred pnevmatike',
      value: euLabel.TIRE_CLASS || euLabel.TIRE_CLASS_E2,
      icon: 'mdi-tag',
    },
    {
      label: '3PMSF',
      value: euLabel.E2_3PMSF ? 'Da' : 'Ne',
      icon: 'mdi-snowflake',
    },
    {
      label: 'Ledeni piktogram',
      value: euLabel.ICE_PICT_E2 ? 'Da' : 'Ne',
      icon: 'mdi-snowflake-variant',
    },
    {
      label: 'EPREL registracija',
      value: euLabel.EPREL_REG_E2,
      icon: 'mdi-certificate',
    },
    {
      label: 'Referenca predpisa',
      value: euLabel.REG_REF || euLabel.REG_REF_E2,
      icon: 'mdi-file-document',
    },
  ];

  const filteredData = labelData.filter(
    (item) =>
      item.value !== null && item.value !== undefined && item.value !== ''
  );

  if (filteredData.length === 0) {
    return (
      <Section>
        <EmptyState
          icon="mdi-label-outline"
          title="Ni informacij o EU oznaki"
          description="Podatki o EU oznaki pnevmatike niso na voljo za ta izdelek"
        />
      </Section>
    );
  }

  return (
    <Section>
      <LabelGrid>
        {filteredData.map((item, index) => (
          <LabelCard
            key={index}
            onMouseEnter={() => setHoveredLabel(item.label)}
            onMouseLeave={() => setHoveredLabel(null)}
          >
            <LabelName>
              {item.icon && <i className={`mdi ${item.icon}`} />}
              {item.label}
              {tooltipTexts[item.label] && (
                <i className="mdi mdi-information-outline" />
              )}
            </LabelName>
            <LabelValue>{item.value}</LabelValue>
            {tooltipTexts[item.label] && (
              <Tooltip visible={hoveredLabel === item.label}>
                {tooltipTexts[item.label]}
              </Tooltip>
            )}
          </LabelCard>
        ))}
      </LabelGrid>
      {euLabel.microsite_eulabel_link && (
        <Link
          href={euLabel.microsite_eulabel_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="mdi mdi-open-in-new" />
          Poglej celotno oznako
        </Link>
      )}
    </Section>
  );
};

TyreEULabel.propTypes = {
  euLabel: PropTypes.object.isRequired,
};

export default TyreEULabel;
